import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import { ClientService } from '../../../api/ClientService';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import moment from 'moment';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

function AdjustBalancesModal({ adamClient, accessToken, balanceUpdate, setBalanceUpdate }) {

    const [curEditingBalanceOffset, setCurEditingBalanceOffset] = useState(null)

    const [asset, setAsset] = useState('USD')
    const [offset, setOffset] = useState('')
    const [note, setNote] = useState('')

    const [adjustmentDate, setAdjustmentDate] = useState(new Date())

    const [show, setShow] = useState(false)

    const [balanceOffsets, setBalanceOffsets] = useState([])
    const [assetList, setAssetList] = useState([])

    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)

    const clientService = new ClientService(accessToken)

    useEffect(() => {
        if(show)
            clientService.getClientBalanceOffsets(adamClient.clientCopperId)
                .then(data => setBalanceOffsets(data))
    }, [adamClient, show])

    useEffect(() => {
        if(show) {
            fetch(`${clientService.API_URL}/tradingpairs/assets`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            }).then(res => res.json())
            .then(data => setAssetList(data.sort((asset1, asset2) => asset1.localeCompare(asset2))))
        }
        else {
            setCurEditingBalanceOffset(null)
        }

    }, [show])

    useEffect(() => {
        if(show) {
            setAsset(curEditingBalanceOffset?.asset ?? '')
            setOffset(curEditingBalanceOffset?.offset ?? '')
            setNote(curEditingBalanceOffset?.note ?? '')

            setAdjustmentDate(curEditingBalanceOffset?.adjustmentDate ?? new Date())
        }

        console.log(curEditingBalanceOffset)
    }, [show, curEditingBalanceOffset])

    const onAdjustBalanceSubmit = () => {
        const parsedOffsetAmount = parseFloat(offset)
        const offsetAmount = isNaN(parsedOffsetAmount) ? 0.0 : parsedOffsetAmount

        const balanceOffsetData = {
            id: curEditingBalanceOffset?.id,
            asset,
            offset: offsetAmount,
            note,
            adjustmentDate
        }

        const reqCallback = () => {
            setShow(false)
            setBalanceUpdate(prevUpdate => prevUpdate + 1)
        }

        if(!curEditingBalanceOffset)
            clientService.createClientBalanceOffset(adamClient.clientCopperId, balanceOffsetData).then(reqCallback)

        else
            clientService.updateClientBalanceOffset(adamClient.clientCopperId, balanceOffsetData).then(reqCallback)
    }

    const onEditBalanceOffset = balanceOffset => {
        setCurEditingBalanceOffset(balanceOffset)
    }

    const onDeleteBalanceOffset = balanceOffset => {
        if(window.confirm('Are you sure you want to delete this balance adjustment?')) {
            clientService.deleteClientBalanceOffset(balanceOffset.id).then(() => {
                setShow(false)
                setBalanceUpdate(prevUpdate => prevUpdate + 1)
            })
        }
    }

    return (
        <>
            <Button size="small" variant="contained" color='success' onClick={handleShow}>
            Adjust Balances
            </Button>
            <Dialog open={show} onClose={handleClose}>
                <DialogContent>
                    <form onSubmit={e => onAdjustBalanceSubmit()}>
                        <div className="row" style={{margin: '5px'}}>
                            <div className="form-group col-md-6">
                                <label style={{fontWeight: 'bold'}}>Client Name:</label>
                                <p>{adamClient.clientPrimaryName}</p>
                            </div>
                        </div>
                        <div className="row" style={{margin: '5px'}}>
                            <div className="form-group col-md-6">
                                <label htmlFor="asset" style={{fontWeight: 'bold'}}>Asset</label>
                                <select className="form-control" name="asset" id="asset" value={asset} onChange={e => setAsset(e.target.value)}>
                                    <option value="">Select...</option>
                                    {
                                        assetList.map(asset => (
                                            <option key={asset} value={asset}>{asset}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="row" style={{margin: '5px'}}>
                            <div className="form-group col-md-6" style={{fontWeight: 'bold'}}>
                                <label htmlFor="offset">Offset Amount</label>
                                <input type="number" step={0.00000001} className="form-control" required name="offset" id="offset" value={offset} onChange={e => setOffset(e.target.value)} />
                            </div>
                        </div>
                        <div className="row" style={{margin: '5px'}}>
                            <div className="form-group col-md-6" style={{fontWeight: 'bold'}}>
                                <label htmlFor="note">Note</label>
                                <input type="text" className="form-control" name="note" id="note" value={note} onChange={e => setNote(e.target.value)} />
                            </div>
                        </div>
                        <div className="form-group col-md-6" style={{fontWeight: 'bold'}}>
                            <label>Adjustment Date</label>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    value={dayjs(adjustmentDate)}
                                    onChange={newDate => setAdjustmentDate(newDate)}
                                    variant='standard'
                                    slotProps={{ textField: { size: 'small' } }}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="btncenter">
                            <input type="submit" className="btn btn-danger" />
                        </div>
                    </form>
                    <div>
                        {balanceOffsets.map(balanceOffset => (
                            <div key={balanceOffset.id} style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ flex: 1 }}>
                                    <p>
                                        {
                                            curEditingBalanceOffset?.id === balanceOffset.id ? 
                                            <>
                                                <b>EDITING</b>
                                                <br />
                                            </>
                                            :
                                            <></>
                                        }
                                        Asset: {balanceOffset.asset}
                                        <br />
                                        Amount: {balanceOffset.offset}
                                        <br />
                                        Note: {balanceOffset.note}
                                        <br />
                                        Date: {moment(balanceOffset.adjustmentDate).format('LLL')}
                                    </p>
                                </div>
                                <div>
                                    <button onClick={() => onEditBalanceOffset(balanceOffset)}>Edit</button>
                                    <button onClick={() => onDeleteBalanceOffset(balanceOffset)}>Delete</button>
                                </div>
                            </div>
                        ))}
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default AdjustBalancesModal
